import SetWorkspace from './views/Set.vue'

export const WorkspaceRoutes = [
  {
    path: '/workspace',
    name: 'Cambiar workspace',
    component: SetWorkspace,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'user:set_workspace'
    }
  }
]
